/**
 * {object} param.configs
 *  {string} param.configs.nameOnCardRegEx
 *  {string} param.configs.CC_VALIDATE_NAME_ON_CARD
 *  {string} param.configs.primaryFirstName
 *  {string} param.configs.primaryLastName
 *  {string} param.configs.jointFirstName
 *  {string} param.configs.jointLastName
 * {string} param.input
 * {object} param.msgs
 *  {string} param.msgs.nameoncard
 *  {string} param.msgs.nameOnCardRegEx
 *  {string} param.msgs.alpha
 */
function nameOnCardValidator({ configs, input, msgs }) {
  const alphaRule = /^[a-zA-Z\- '’]+$/;
  const nameOnCardRegEx = configs.nameOnCardRegEx ? new RegExp(configs.nameOnCardRegEx) : null;

  /* This does not work logically, but it needs to match the Java validator for consistency */
  if (configs.CC_VALIDATE_NAME_ON_CARD === 'true') {
    // Does not include the full primary or secondary name
    if (
      (!input?.toLowerCase().includes(configs.primaryFirstName?.toLowerCase()) ||
        !input.toLowerCase().includes(configs.primaryLastName?.toLowerCase())) &&
      (!input?.toLowerCase().includes(configs.jointFirstName?.toLowerCase()) ||
        !input.toLowerCase().includes(configs.jointLastName?.toLowerCase()))
    ) {
      return msgs.nameoncard || "Name on card must contain an applicant's name";
    }
  } else {
    if (nameOnCardRegEx && !nameOnCardRegEx.test(input)) {
      return msgs.nameOnCardRegEx || 'Value needs to match the nameOnCardRegEx validator rules.';
    }
    if (!alphaRule.test(input)) {
      return msgs.alpha || 'Numbers and special characters are not allowed in this field.';
    }
  }

  return null;
}

export default nameOnCardValidator;
